<ax-header>
  <ax-title>
    <div class="ax-flex ax-cursor-pointer ax-items-center ax-gap-2 ax-text-sm"
      [routerLink]="['', _platfromService.siteLanguage()]">
      <img src="{{ env }}/{{ settingData.logo }}" [alt]="settingData.pageTitle" class="ax-h-12 ax-object-contain" />

      <div class="max-[900px]:ax-hidden"></div>
    </div>
  </ax-title>
</ax-header>
<ax-content>
  <div class="ax-flex ax-flex-col ax-justify-between ax-p-4" style="height: calc(100% - 73px);">
    <div class="">
      <ng-container *ngIf="userProfile; else elseTemplate">
        <p class="ax-text-sm" *ngIf="userProfile">{{userProfile.firstName ? userProfile.firstName :
          userProfile.username}}
        </p>

        <div class="ax-flex ax-bg-warning-100 ax-justify-between ax-items-center ax-p-2 ax-rounded-lg ax-mt-4"
          *ngIf="showWallet">
          <span class="ax-text-neutral-500 ax-text-xs ax-flex ax-items-center">
            <ax-icon>
              <i class="fa-solid fa-wallet ax-text-warning-500 ax-pl-2"></i>
            </ax-icon>
            {{'wallet.walletBalance' | translate | async}}</span>
          <span class="ax-text-xs">
            <strong>{{ walletBalanceWl.balance | number }}</strong>
            {{ walletBalanceWl.moneySymbol? walletBalanceWl.moneySymbol: 'common.currency' | translate | async }}
          </span>
        </div>
        <hr *ngIf="userProfile" class="ax-my-4">
        <ax-menu [orientation]="'vertical'">
          @for (headerMenu of headerMenuItemList; track $index) {
          <ax-menu-item [text]="headerMenu.text" class="ax-justify-start" (onClick)="_handleOnItemClick(headerMenu)">
            <ax-prefix>
              <ax-icon>
                <i [class]="headerMenu.icon"></i>
              </ax-icon>
            </ax-prefix>
          </ax-menu-item>
          }
        </ax-menu>
      </ng-container>
      <ng-template #elseTemplate>
        <ax-button [text]="('header.login' | translate | async) + '/' + ('header.register' | translate | async)"
          color="primary" (onClick)="loginPopup()" *ngIf="!userProfile" class="ax-md ax-w-full">
        </ax-button>
        <hr>
      </ng-template>
      <a href="tel:{{ settingData.supportMobile }}" class="ax-my-4 ax-flex btn">
        <ax-button [text]="('header.support' | translate | async)" look="blank" class="">
          <ax-prefix *ngIf="isMobile">
            <ax-icon class="fa-solid fa-headset"></ax-icon>
          </ax-prefix>
        </ax-button>
      </a>
    </div>
    <div class="ax-flex ax-flex-col ax-gap-4">
      <div class="ax-flex ax-w-full ax-items-center ax-justify-between ax-gap-2 ">
        <div class="ax-flex">
          <ax-icon>
            <i class="fa-solid fa-brightness" *ngIf="themeService.themeMode === 'dark'"></i>
            <i class="fa-solid fa-moon" *ngIf="themeService.themeMode === 'light'"></i>
          </ax-icon>
          <span class="ax-text-sm ax-pr-2">حالت شب</span>
        </div>
        <ax-switch (onValueChanged)="themeService.switchMode()"
          [color]="themeService.themeMode === 'light' ? 'ghost' : 'warning'"></ax-switch>
      </div>

      <!-- خروج از حساب کاربری -->
      <hr *ngIf="userProfile">
      <ax-button [text]="('header.logout' | translate | async)!" color="danger" name="logout" look="blank"
        *ngIf="userProfile" class="!ax-w-fit btn" (onClick)="onHndleLogOut()">
        <ax-prefix>
          <i class="fa-solid fa-right-from-bracket"></i>
        </ax-prefix>
      </ax-button>

    </div>
  </div>
</ax-content>